import { render, staticRenderFns } from "./AutoCampaignSettings.vue?vue&type=template&id=206938ed&scoped=true&"
import script from "./AutoCampaignSettings.vue?vue&type=script&lang=js&"
export * from "./AutoCampaignSettings.vue?vue&type=script&lang=js&"
import style0 from "./AutoCampaignSettings.vue?vue&type=style&index=0&id=206938ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206938ed",
  null
  
)

export default component.exports